var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToastCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.707 6.70703L13.4141 12L18.707 17.293L17.293 18.707L12 13.4141L6.70703 18.707L5.29297 17.293L10.5859 12L5.29297 6.70703L6.70703 5.29297L12 10.5859L17.293 5.29297L18.707 6.70703Z",
    fill: "#056764"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastCross);
export default __webpack_public_path__ + "static/media/toast-cross.2fb52893fadcfe6918c80d6451cfd645.svg";
export { ForwardRef as ReactComponent };